import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'accent' | 'outline' | 'light';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-[0.15em] leading-none';
  const variants = {
    default: 'bg-[#1A1A2E] text-white',
    accent: 'bg-[#C9A227] text-[#1A1A2E]',
    outline: 'bg-transparent border border-[#1A1A2E]/20 text-[#1A1A2E]',
    light: 'bg-white/90 backdrop-blur-sm text-[#1A1A2E] shadow-sm'
  };
  return <span className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-12">
      {children}
    </span>;
}